export const environment = {
    config: {
        apiKey: "AIzaSyAMhYs-LIozIGJSZG7OTWhrfgKc2y3YhN4",
        authDomain: "asambleas-dev.firebaseapp.com",
        databaseURL: "https://asambleas-dev.firebaseio.com",
        projectId: "asambleas-dev",
        storageBucket: "",
        messagingSenderId: "394118623296"
    },
    production: false,
    //apiEndPoint: 'http://localhost:8000',
    apiEndPoint: 'https://asambleas-api-dev.herokuapp.com',
    docMasiveUserLoad: 'https://docs.google.com/spreadsheets/d/1ulgNqfkSZdUbu9ThSVoni33YMZRR4EuscYPXXleqKtQ/export?format=xlsx'
};

export const TABLES_CONFIG = {
    ROW_NUMBER: [10, 15, 25, 50]
}

export enum NOTIFICATIONS_TYPES {
    DeleteChurch = 'delete_church',
    DeleteUser = 'delete_user'
}

export const PATHS = {
    USER: {
        UPDATE: '/usuarios/update-information'
    },
    ROLES: {
        ALL: 'roles/all'
    }
}

export const JSON_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts